// TODO: 기획서상 단어이므로 변경이 필요하면 수정
/** 주문상태 카테고리 */
export const SaleStatusCategory = {
    /** 결제대기중 */
    PAY_WAIT: 'PAY_WAIT',
    /** 신규주문 */
    NEW_ORDERS: 'NEW_ORDERS',
    /** 배송준비중/배송중 */
    DELIVERY: 'DELIVERY',
    /** 배송완료 */
    DELIVERED: 'DELIVERED',
    /** 구매확정 */
    PURCHASE_DECIDED: 'PURCHASE_DECIDED',
    /** 취소 */
    CANCEL: 'CANCEL',
    /** 반품 */
    RETURN: 'RETURN',
} as const
export type SaleStatusCategoryType = Constant<typeof SaleStatusCategory>

const StatusCategoryCodeToNameMap: Record<SaleStatusCategoryType, string> = {
    PAY_WAIT: '결제 대기중',
    NEW_ORDERS: '결제완료',
    DELIVERY: '배송준비중/배송중',
    DELIVERED: '배송완료',
    PURCHASE_DECIDED: '구매확정',
    CANCEL: '취소',
    RETURN: '반품',
}

export const getStatusCategoryCodeToName = (code: SaleStatusCategoryType) => {
    return StatusCategoryCodeToNameMap[code] ?? ''
}

/** 주문상태 요약 */
export interface SaleStatusSummary {
    /** 카테고리 */
    category: SaleStatusCategoryType
    /** 카테고리에 해당하는 내역 개수 */
    itemCount: number
}

/**
 * 주문상태
 * @see https://oss.fin.navercorp.com/payOrder/order/blob/develop/order_customer/src/main/webapp/static/js/service/front/order/formatter/codes.js#L1714
 * @remarks 기획서에 있는 상태만 작성
 * @remarks StatusCategory와 mapping 필요
 */
export const SaleStatus = {
    /** 신규주문 */
    NEW_ORDERS: 'NEW_ORDERS',
    /** 결제대기중 */
    PAY_WAIT: 'PAY_WAIT',
    /** 상품준비중 */
    PRODUCT_PREPARE: 'PRODUCT_PREPARE',
    /** 발송지연 */
    DELAYED_DISPATCH: 'DELAYED_DISPATCH',
    /** 취소요청 */
    CANCEL_REQUEST: 'CANCEL_REQUEST',
    /** 취소완료 */
    CANCEL_DONE: 'CANCEL_DONE',
    /** 배송준비중 */
    DELIVERY_READY: 'DELIVERY_READY',
    /** 배송중 */
    DELIVERING: 'DELIVERING',
    /** 배송완료 */
    DELIVERED: 'DELIVERED',
    /** 미결제취소완료 */
    CANCELED_BY_NOPAYMENT: 'CANCELED_BY_NOPAYMENT',
    /** 반품요청 */
    RETURN_REQUEST: 'RETURN_REQUEST',
    /** 반품수거완료 */
    RETURN_COLLECT_DONE: 'RETURN_COLLECT_DONE',
    /** 반품환불완료 */
    RETURN_REFUND: 'RETURN_REFUND',
    /** 구매확정완료 */
    PURCHASE_DECIDED: 'PURCHASE_DECIDED',
} as const
export type SaleStatusType = Constant<typeof SaleStatus>

export type SaleHistoryState = {
    /** 결제 일시 (ISO 형식) */
    paymentDate: string
    /** 주문상태 요약 리스트 */
    statusSummaries: SaleStatusSummary[]
}

export type RootState = {saleHistory: SaleHistoryState}
